import {signInGoogle} from "@/api/kisi";
import Cookies from "js-cookie";

export async function GoogleIdToken(gapi) {

    const auth2 = await gapi._libraryLoad('auth2');
    const GoogleAuth = await auth2.init(gapi.config);
    if (GoogleAuth.isSignedIn.get()) {
        const id_token=GoogleAuth.currentUser.get().getAuthResponse().id_token;
        return Promise.resolve(id_token);
    }
    return Promise.resolve(false);
}

export async function GoogleTokenIleGirisYapmayiDene(that, kkullanici, ksifre) {
    const token = await new GoogleIdToken(that.$gapi);
    if (token)
        return new CaizseGirisYap(that, token, kkullanici, ksifre);
    return Promise.resolve(false);
}

export async function GoogleIleGirisYap(that, kkullanici, ksifre) {
    const auth2 = await that.$gapi._libraryLoad('auth2');
    const GoogleAuth = await auth2.init(that.$gapi.config);
    await GoogleAuth.signIn();
    return new GoogleTokenIleGirisYapmayiDene(that, kkullanici, ksifre);
}


export async function CaizseGirisYap(that, token, kkullanici, ksifre) {

    const gelen = await signInGoogle(token, kkullanici, ksifre,that.$route.query.eposta);

    if (gelen.hataVarMi) {
        that.$notify({
            group: 'ust',
            type: 'error',
            title: 'Hata',
            text: gelen.mesaj
        });
        return Promise.resolve(gelen);
    }
    const kisi = gelen.data;
    that.$store.commit('setKisi', kisi);

    that.$notify({
        group: 'ust',
        title: 'Giriş Başarılı',
        text: kisi.isim + " olarak giriş yapıldı"
    });
    console.log(kisi.isim + " olarak giriş yapıldı");
    return Promise.resolve(true);
}

